import React from 'react'
import * as ReactDOM from 'react-dom'

const LoadingPanel = (props) => {
  const { gridComponent } = props
  const loadingPanel = (
    <div className='k-loading-mask grid-loader'>
      <span className='k-loading-text' />
      <div className='k-loading-image' />
      <div className='k-loading-color' />
    </div>
  )
  const gridContent = gridComponent && gridComponent.querySelector('.k-grid-content')
  return gridContent ? ReactDOM.createPortal(loadingPanel, gridContent) : loadingPanel
}

export {
  LoadingPanel
}